/**
 * @module experience/landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
// Core Libraries
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// interfaces
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
import {
  CustomerSessionPassDetailsLineDetailsPassDetails,
  CustomerSessionPassDetailsLineDetailsPassDetailsActive,
  CustomerSessionPassDetailsLineDetails,
} from '@support/api/proxies/responses/api-2010.interface';
import { CustomerUsageSummaryResultsLines } from '@support/api/proxies/responses/api-2009.interface';

// services
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { LineLandingService } from '@experience/landing/common/services/line-landing.service';
// Constants
import { ACCOUNT_LANDING_CONSTANTS } from '@experience/landing/common/constants/account-landing.constants';
@Component({
  selector: 'tmo-one-time-charges',
  templateUrl: './one-time-charges.component.html',
})
export class OneTimeChargesComponent implements OnInit, OnDestroy {
  /**
   * stores content data
   */
  @Input() public contentData: ConfigData;
  /**
   * stores the line usage summary of customer
   */
  @Input() public lineUsageSummary: CustomerUsageSummaryResultsLines;
  /**
   * stores value of showOnLineDetails flag
   */
  @Input() public showOnLineDetails: boolean;
  /**
   * stores session pass data
   */
  @Input() public passDetails: CustomerSessionPassDetailsLineDetailsPassDetails;

  /**
   * Stores total value of future one time charges
   */
  public futureOneTimeCharges: number;
  /**
   * checks if  the billing type is prepaid or not.
   */
  public isBillingTypePrepaid: boolean;
  /**
   * Unsubscriber for all subscribtions
   */
  private ngUnsubscribe: Subject<void>;
  /**
   * Variable to hold selected session pass details
   */
  public selectedLineSessionPassDetails: CustomerSessionPassDetailsLineDetails;
  constructor(
    private objectService: ObjectService,
    private stateStoreUtilsService: StateStoreUtilsService,
    private lineLandingService: LineLandingService
  ) {
    this.isBillingTypePrepaid = false;
    this.ngUnsubscribe = new Subject<void>();
    this.futureOneTimeCharges = 0;
  }

  /**
   * Loads the initial data of One Time Charges Page
   * @returns void
   */
  public ngOnInit(): void {
    if (
      this.stateStoreUtilsService.getBillingTypeOfCustomerInFocus().toLocaleUpperCase() ===
      ACCOUNT_LANDING_CONSTANTS.PREPAID
    ) {
      this.isBillingTypePrepaid = true;
    }
    this.totalFutureCharges();
    this.lineLandingService.selectedMsidin.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.totalFutureCharges();
    });
  }
  /**
   * Unsubscribes for all subscriptions
   * @returns void
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private totalFutureCharges(): void {
    const futureDetails = this.objectService.get(this.passDetails, 'future');
    if (futureDetails) {
      futureDetails.forEach((item: CustomerSessionPassDetailsLineDetailsPassDetailsActive) => {
        this.futureOneTimeCharges = this.futureOneTimeCharges + +item.purchasePrice;
      });
    }
  }
}
